"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9502],{

/***/ 90756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SecurityLogos; }
});

// UNUSED EXPORTS: LOGO_SIZES

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/security-logos/security-logos.scss.js


var StyledSecurityLogos = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1q2zonn0"
})("display:flex;flex-wrap:wrap;justify-content:center;.security-logo-wrapper{&:not(:last-child){margin-right:24px;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){margin-right:20px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){margin-right:16px;}}.security-logo{height:72px;&.small-logo{height:48px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/security-logos/default-props.js
/* harmony default export */ var default_props = ({
    logosNumber: 5,
    smallLogos: false
});

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/core-components/security-logos/security-logos.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var LOGO_SIZES = {
    LARGE: "large",
    MEDIUM: "medium"
};
var LOGOS = [
    "/static/img/security/gdpr_v2.png",
    "/static/img/security/iso_27001_v2.png",
    "/static/img/security/iso_27018_v2.png",
    "/static/img/security/soc_v2.png",
    "/static/img/security/hipaa_v2.png"
];
var SecurityLogos = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SecurityLogos, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SecurityLogos);
    function SecurityLogos() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SecurityLogos);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLogo", function(logo, index) {
            var smallLogos = _this.props.smallLogos;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "security-logo-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: logo,
                    className: classnames_default()("security-logo", {
                        "small-logo": smallLogos
                    })
                })
            }, index);
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SecurityLogos, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var logosNumber = this.props.logosNumber;
                var logosToRender = LOGOS.slice(0, logosNumber);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecurityLogos, {
                    className: "security-logos",
                    children: logosToRender.map(function(logo, index) {
                        return _this.renderLogo(logo, index);
                    })
                });
            }
        }
    ]);
    return SecurityLogos;
}(react.PureComponent);

SecurityLogos.defaultProps = default_props;


/***/ }),

/***/ 49502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LogosAndHeaderSecurityComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/security/layouts/logos-and-header-security/logos-and-header-security-component.scss.js


var StyledLogosAndHeaderSecurityComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqiz4eg0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding:0px 32px;text-align:center;.security-logos-wrapper{margin-top:24px;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/security-logos/security-logos.js + 2 modules
var security_logos = __webpack_require__(90756);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/security/layouts/logos-and-header-security/logos-and-header-security-component.js










var LogosAndHeaderSecurityComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LogosAndHeaderSecurityComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LogosAndHeaderSecurityComponent);
    function LogosAndHeaderSecurityComponent() {
        (0,_class_call_check/* default */.Z)(this, LogosAndHeaderSecurityComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LogosAndHeaderSecurityComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, titleSize = _props.titleSize;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLogosAndHeaderSecurityComponent, {
                    className: "logos-and-header-security-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                            title: title,
                            titleSize: titleSize
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "security-logos-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(security_logos/* default */.Z, {})
                        })
                    ]
                });
            }
        }
    ]);
    return LogosAndHeaderSecurityComponent;
}(react.PureComponent);

LogosAndHeaderSecurityComponent.defaultProps = {
    title: "Compliance certifications and regulations",
    titleSize: sizes.LG,
    paddingTop: "64px",
    paddingBottom: "64px"
};


/***/ })

}]);